import React from "react";
import { Leaf } from "lucide-react";

export function Brand({ light = false, subtitle = true }) {
  return (
    <div className="flex items-center gap-3">
      <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-emerald-600 text-white shadow-sm">
        <Leaf className="h-5 w-5" />
      </div>
      <div className="leading-tight">
        <div className={`font-heading text-base font-extrabold tracking-tight ${light ? "text-white" : "text-[#0a192f]"}`}>
          Çevre Belge Portalı
        </div>
        {subtitle && (
          <div className={`text-[11px] font-medium ${light ? "text-slate-300" : "text-slate-500"}`}>
            Danışmanlık Belge Yönetimi
          </div>
        )}
      </div>
    </div>
  );
}

export default Brand;
